import PropTypes from "prop-types";
import React from "react";
import MDBox from "../../MDBox";
import MDInput from "../../MDInput";
import GenericQuizExecutor from "../../GenericQuiz/executor.js";
import ValidationHint from "../../GenericQuiz/validation-hint.js";

function Executor(props) {
  return (
    <GenericQuizExecutor {...props} activityEndpoint={"mathcalculations"}>
      {({ question, answer, onAnswerChange, valid, validAnswer, submit }) => (
        <>
          <MDBox sx={{ fontSize: "2.2rem", mb: 2, fontWeight: "bold" }}>Résous ce calcul :</MDBox>
          <MDBox display="flex" alignItems="center" sx={{ fontSize: "2.2rem", "& > *": { mr: 1 } }}>
            <span>{question.left}</span>
            <span>{question.sign}</span>
            <span>{question.right}</span>
            <span>=</span>
            <MDInput
              type={valid === 0 ? "number" : undefined}
              name="answer"
              value={answer || answer === 0 ? answer : ""}
              onChange={(e) => onAnswerChange({ target: { value: parseFloat(e.target.value) } })}
              onKeyUp={(e) => {
                if (e.keyCode === 13) {
                  submit();
                }
              }}
              readOnly={valid > 0}
              success={valid === 1}
              error={valid === 2 || valid < 0}
              focused={true}
              sx={{
                "& .MuiInputBase-input": { fontSize: "2.2rem", width: 150, textAlign: "center" },
              }}
            />
          </MDBox>
          <ValidationHint valid={valid} validAnswer={validAnswer} />
        </>
      )}
    </GenericQuizExecutor>
  );
}
Executor.propTypes = {
  params: PropTypes.object,
  onEnd: PropTypes.func,
};

export default Executor;
